<template>
	<div class="p-grid irinox-form spare-parts">
    <!-- <div class="p-col-12 p-pt-1 p-pb-1 p-d-flex p-jc-between p-ai-center">
      <p>{{ $t('afterSales.tab_spareParts') }}</p>
    </div> -->

    <div class="p-col-12 p-d-flex p-ai-center">
      <div v-if="sparePartsDocs && sparePartsDocs.pages && sparePartsDocs.pages.length>0" class="p-col-12 p-d-flex p-flex-wrap p-ai-center " style="gap: 20px" >
        <div v-for="(doc, index) in sparePartsDocs?.pages" :key="index" class="spare-parts-drawing-thumbnail" @click="goTo(sparePartsDocs.spDocsId, index+1)">
          <img :src="doc.thumbnail" :alt="'DRAWINGS'" />
          {{ $t('spareParts.drawing') + ' ' + (index+1) }}
          <!-- <Button :label="$t('spareParts.drawing') + ' ' + (index+1)" @click="goTo(1, 14)" /> -->
        </div>
      </div>
      <div v-else class="p-col-12 p-d-flex p-ai-center">
        <span>{{ $t('spareParts.empty') }}</span>
      </div>
    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
</template>

<script>
import AfterSalesService from '../../service/AfterSalesService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
export default {
  components: { 
    IrinoxDialogDark 
  },
  props: {
    docTreeId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      dialog: {
        error: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      sparePartsDocs: 'afterSales/sparePartsDocs',
    }),
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
    this.loadDocs();
  },
  methods: {
    loadDocs() {
      this.afterSalesService.getSparePartsDocs(this.personaltoken, this.docTreeId)
        .then((data) => {
          if(data.code=="200") {
            this.$store.commit('afterSales/sparePartsDocs', data.body);
          } else {
            console.error(JSON.stringify(data));
            this.$store.commit('afterSales/sparePartsDocs', null);
            this.dialog.error = true;
          }
          })
        .catch(error => {
          console.error("ERROR "+error);
          this.$store.commit('afterSales/sparePartsDocs', null);
          this.dialog.error = true;
        });
    },
    goTo(spDocsId, page) {
      this.$router.push({ name: 'after-sales-spare-parts', params: { docTreeId: this.docTreeId, table: this.$functions.crypt("table", spDocsId+"|||"+page) } });
    }
  }
}

</script>

<style scoped>
</style>